import React, { useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCog, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import "./Account.css";

function Account({ id, name }) {
  const { changeAccount } = useContext(AuthContext);

  const { t } = useTranslation();

  return (
    <Row className="account align-items-center">
      <Col lg={11} className="account-header">
        <h5 className="link-like" onClick={() => changeAccount(id)}>
          {name}
        </h5>
      </Col>
      <Col lg={1} className="account-content">
        <Dropdown>
          <Dropdown.Toggle id="dropdown-basic">
            <FontAwesomeIcon icon={faCog} />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item as={Link} to={`/accounts/edit/${id}`}>
              <FontAwesomeIcon icon={faEdit} /> {t("Cuentas.Cuenta.Editar")}
            </Dropdown.Item>
            <Dropdown.Item as={Link} to={`/accounts/delete/${id}`}>
              <FontAwesomeIcon icon={faTrash} /> {t("Cuentas.Cuenta.Eliminar")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Col>
    </Row>
  );
}

export default Account;
